import { __decorate, __extends } from "tslib";
import { FilterUtils, PROPS_LIST, proxyTo, serialisable } from '../utils/FilterUtils';
import { BlurFilter } from './BlurFilter';
import { BevelTask } from './tasks/webgl/BevelTask';
var BevelFilter = /** @class */ (function (_super) {
    __extends(BevelFilter, _super);
    function BevelFilter(options) {
        var _this = _super.call(this, options) || this;
        _this._bevelTask = new BevelTask();
        _this.distance = 1;
        _this.angle = 45;
        _this.highlightColor = 0xffffff;
        _this.highlightAlpha = 1;
        _this.shadowColor = 1;
        _this.shadowAlpha = 0;
        _this.alphas = [];
        _this.colors = [];
        _this.ratios = [];
        _this.strength = 1;
        _this.type = 'inner';
        _this.knockout = false;
        _this.addTask(_this._bevelTask);
        _this.applyProps(options);
        return _this;
    }
    BevelFilter.prototype.applyProps = function (model) {
        // run all model field that changed
        for (var _i = 0, _a = this[PROPS_LIST]; _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in model) {
                this[key] = model[key];
            }
        }
    };
    BevelFilter.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input; }
        var pad = FilterUtils.meashureBlurPad(this.blurX, this.blurY, 3, false);
        target.copyFrom(input);
        // for outer or both need render a drop shadow with valid pad
        var dist = this.distance;
        if (this.type !== 'inner' && dist > 0) {
            var rad = this.angle * Math.PI / 180;
            pad.x += Math.sin(rad) * dist * 2;
            pad.y += Math.sin(rad) * dist * 2;
        }
        target.x -= pad.x;
        target.y -= pad.y;
        target.width += pad.x;
        target.height += pad.y;
        return target;
    };
    BevelFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManager) {
        _super.prototype.setRenderState.call(this, source, target, sourceRect, outRect, filterManager);
        var subtarget = this._hBlurTask.target;
        var secondPass = filterManager.popTemp(subtarget.width, subtarget.height);
        // emit real
        // crop a dest rectanle
        // ovveride blur target
        // we use a copyFrom, because if we will use referece - we can corrupt instance
        this._bevelTask.inputRect.copyFrom(this._vBlurTask.inputRect);
        this._bevelTask.destRect.copyFrom(outRect);
        //reset output size
        this._vBlurTask.inputRect.setTo(0, 0, 0, 0);
        this._vBlurTask.destRect.setTo(0, 0, 0, 0);
        // and reset target
        this._vBlurTask.target = secondPass;
        this._bevelTask.source = secondPass;
        this._bevelTask.sourceImage = source;
        this._bevelTask.target = target;
        this._temp.push(secondPass);
    };
    BevelFilter.filterName = 'bevel';
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "distance", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "angle", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "highlightColor", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "highlightAlpha", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "shadowColor", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "shadowAlpha", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "alphas", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "colors", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "ratios", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "strength", void 0);
    __decorate([
        serialisable
    ], BevelFilter.prototype, "quality", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "type", void 0);
    __decorate([
        serialisable,
        proxyTo('_bevelTask')
    ], BevelFilter.prototype, "knockout", void 0);
    return BevelFilter;
}(BlurFilter));
export { BevelFilter };
